import { trackRaw } from '@mote/api'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'
import type { MoteRecorderError } from '@mote/helpers/hooks/recorder/errors'
import { moteRecorderErrorMessages } from '@mote/helpers/hooks/recorder/errors'

export type Payload = Record<string, any>

export interface TrackerConfig {
  startPayload: Payload
  finalizePayload: Payload
}

export class Tracker {
  config: TrackerConfig

  constructor(config: TrackerConfig) {
    this.config = config
  }

  recordStart() {
    this.#track({
      event: TRACK_EVENT_NAMES.mote.record.start,
      ...this.config.startPayload
    })
  }

  recordFinalized(
    duration: number,
    assetId: string,
    transcriptionLanguage: string
  ) {
    this.#track({
      event: TRACK_EVENT_NAMES.mote.action.create,
      contentAssetId: assetId,
      assetLength: duration,
      transcriptionLanguage,
      ...this.config.finalizePayload
    })
  }

  quotaExhausted() {
    this.#track({
      event: TRACK_EVENT_NAMES.quota.exhausted
    })
  }

  microphoneRequestTriggered() {
    this.#track({
      event: TRACK_EVENT_NAMES.permission.microphone.requestTriggered
    })
  }

  microphoneRequestEnabled() {
    this.#track({
      event: TRACK_EVENT_NAMES.permission.microphone.requestEnabled
    })
  }

  microphoneRequestBlocked() {
    this.#track({
      event: TRACK_EVENT_NAMES.permission.microphone.requestBlocked
    })
  }

  errorOccurred<T extends object>(error: MoteRecorderError, payload?: T) {
    const values = moteRecorderErrorMessages[error]
    this.#track({
      event: TRACK_EVENT_NAMES.error.occurred,
      reason: values.title,
      display: values.description,
      errorCode: error,
      ...payload
    })
  }

  #track(json: object) {
    /*
      TODO: Inject that we should use track raw because of it's dependencies (extension/web).
            It should inject proper payload through the constructor
     */
    return trackRaw({ variables: { ...json, recordingEngine: 'v4' } }).catch(
      () => {
        /* NOOP */
      }
    )
  }
}
